export default __webpack_public_path__ + "static/media/hinge1.1fc9c360.jpg";